"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_redux_1 = require("react-redux");
const react_i18next_1 = require("react-i18next");
const svgs_1 = require("@@/assets/svgs");
const functions_1 = require("@/common/functions");
const string_utils_1 = require("@/common/string_utils");
const Grid_1 = __importDefault(require("@mui/material/Grid"));
const styled_1 = __importDefault(require("@emotion/styled"));
const _1 = require(".");
function default_1({ product, productIndex, onPhotoClick, }) {
    var _a;
    const { id: productId, images, name, price, isSoldOut, remain_stock: remainStock } = product;
    const imgUrl = ((_a = images[0]) === null || _a === void 0 ? void 0 : _a.img_url) || '';
    const salesClosed = (0, react_redux_1.useSelector)((state) => state.roomData.salesClosed);
    const isNotAvailable = isSoldOut || salesClosed;
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)(ProductBarDiv, { children: [(0, jsx_runtime_1.jsxs)("div", Object.assign({ css: {
                    position: 'relative',
                    width: '48px',
                    height: '48px',
                    '&:after': (0, functions_1.afterImgWrapper)({ borderRadius: '4px' }),
                    '> .inner_item': {
                        width: '100%',
                        height: '100%',
                        borderRadius: '4px',
                        cursor: imgUrl ? 'pointer' : 'unset',
                        objectFit: 'cover',
                    },
                } }, { children: [imgUrl ? ((0, jsx_runtime_1.jsx)("img", { className: "inner_item", src: (0, functions_1.getCdnUrl)(imgUrl), onClick: () => onPhotoClick(productId) })) : ((0, jsx_runtime_1.jsx)("div", { className: "inner_item surface-table-row" })), !!imgUrl && ((0, jsx_runtime_1.jsx)(svgs_1.ExpandGrayCircleSvg, { css: { position: 'absolute', bottom: '3px', right: '3px', pointerEvents: 'none' } }))] })), (0, jsx_runtime_1.jsxs)(Grid_1.default, Object.assign({ container: true, direction: "column", justifyContent: "space-around", height: "100%" }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ className: 'product_name text_overflow'.concat(isNotAvailable ? ' sold_out' : '') }, { children: name })), (0, jsx_runtime_1.jsxs)("div", Object.assign({ className: 'product_price'.concat(isNotAvailable ? ' sold_out' : '') }, { children: [(0, string_utils_1.money)(price), t('원')] })), !isNotAvailable && remainStock < 10 && ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: "sold_out_warning" }, { children: `${t('품절임박')} (${t('remainStock개 남음', { remainStock })})` })))] })), (0, jsx_runtime_1.jsx)(_1.ProductAddButton, { productId: productId, productIndex: productIndex, isNotAvailable: isNotAvailable, salesClosed: salesClosed })] }));
}
exports.default = default_1;
const ProductBarDiv = styled_1.default.div `
  position: relative;
  display: grid;
  grid-template-columns: 48px auto;
  column-gap: 10px;
  align-items: center;
  height: 64px;
  padding: 6px 8px;
  border-radius: 4px 4px 24px;
  background-color: #f8f8f8;
  .product_name {
    /* .text_overflow in base_react.html */
    -webkit-line-clamp: 1;
    line-height: 16px;
    font-size: 14px;
  }
  .product_price {
    line-height: 19px;
    font-size: 15px;
    font-weight: 700;
  }
  .sold_out_warning {
    line-height: 13px;
    font-size: 11px;
    color: #f55a5a;
  }
  .sold_out {
    color: rgba(0, 0, 0, 0.26);
  }
`;
